import React, { useState, useEffect, useCallback, memo } from 'react';
import classNames from 'classnames/bind';

const cx = classNames.bind(null);

function ImageComm({ hasSrc, imgSrc = '', imgDataSrc = '', noImgSrc = '', alt = '', classArray = null, style = null, useSrcReturnOff = false, testId = '', useFileNameCheck = false }) {
	const [src, setSrc] = useState(useSrcReturnOff ? imgSrc : '');
	const [fileCheck, setFileCheck] = useState([
		{
			file: '.jpg',
			stats: true,
		},
		{
			file: '.JPG',
			stats: false,
		},
		{
			file: '.peg',
			stats: false,
		},
		{
			file: '.gif',
			stats: false,
		},
	]);

	const handleError = useCallback(() => {
		if (useFileNameCheck) {
			const chkIndex = fileCheck.findIndex((n) => !n.stats);
			if (chkIndex === -1) {
				setSrc(noImgSrc);
			} else {
				setFileCheck((prev) =>
					prev?.map((item, i) => ({
						...item,
						stats: !item.stats ? i === chkIndex : true,
					})),
				);
				setSrc(src.replace(fileCheck[chkIndex - 1].file, fileCheck[chkIndex].file));
			}
		} else {
			setSrc(noImgSrc);
		}
	}, [src, noImgSrc, fileCheck, useFileNameCheck]);

	useEffect(() => {
		if (useSrcReturnOff) {
			return;
		}

		setSrc(hasSrc ? imgSrc : noImgSrc);
	}, [hasSrc, imgSrc, noImgSrc, useSrcReturnOff]);

	if (src === '' && !useSrcReturnOff) return null;

	return (
		<>
			<img
				src={src}
				alt={alt}
				onError={handleError}
				className={cx(classArray)}
				style={style}
				data-src={imgDataSrc}
				data-testid={testId}
			/>
		</>
	);
}

export default memo(ImageComm);
